import React from 'react'
import { SignFormStep2 } from '@shared/components/forms/sign/steps/step2/form'

export const View = () => <SignFormStep2 />
